export default function Badge({ children, color = "primary" }) {
    const colorMap = {
      success: "badge--success",
      danger: "badge--danger",
      warning: "badge--warning",
      primary: "badge--primary",
      muted: "badge--muted",
    };
    return <span className={`badge ${colorMap[color] || colorMap.primary}`}>{children}</span>;
  }